import { jsx } from "react/jsx-runtime";
import { SpaceLg } from "@nxt-costco-com/forge-design-tokens";
import { ProductTileCarouselClient } from "../ProductTileCarousel/ProductTileCarouselClient.js";
import { CostcoBox } from "../../../Util/CostcoBox.js";
const LucidWorksCarousel = ({
  entry,
  locale,
  titleProps,
  maxSlides,
  productTileSx,
  carouselContainerSx,
  sx = {},
  isProductDetailsPage,
  itemIds = []
}) => {
  if (!entry || itemIds.length === 0) {
    return null;
  }
  const {
    product_card_display_style,
    show_reviews,
    show_action_button,
    inventory_aware_listings
  } = entry.product_display_style;
  return /* @__PURE__ */ jsx(
    CostcoBox,
    {
      sx: {
        width: isProductDetailsPage ? "100%" : `calc(100% - ${SpaceLg})`
      },
      children: /* @__PURE__ */ jsx(
        ProductTileCarouselClient,
        {
          analytics: {},
          containerSx: carouselContainerSx,
          inventoryAware: inventory_aware_listings,
          isProductDetailsPage,
          itemNumbers: itemIds,
          locale,
          maxSlides,
          pageType: void 0,
          productTileSx,
          showActionButton: show_action_button,
          showReviews: show_reviews,
          sx,
          testId: "LucidWorks_Products",
          titleProps,
          variant: product_card_display_style,
          wrapAround: isProductDetailsPage ? false : void 0,
          ...isProductDetailsPage && { peekAdjacent: "1rem" },
          ...isProductDetailsPage && { wrapAround: false }
        }
      )
    }
  );
};
export {
  LucidWorksCarousel
};
